import { useTranslation } from 'react-i18next';

export default function ComparisonSection() {
  const { t } = useTranslation();

  const rows = [
    { label: t('comparison.f1'), s: t('comparison.f1s'), n: t('comparison.f1n') },
    { label: t('comparison.f2'), s: t('comparison.f2s'), n: t('comparison.f2n') },
    { label: t('comparison.f3'), s: t('comparison.f3s'), n: t('comparison.f3n') },
    { label: t('comparison.f4'), s: t('comparison.f4s'), n: t('comparison.f4n') },
    { label: t('comparison.f5'), s: t('comparison.f5s'), n: t('comparison.f5n') },
  ];

  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            {t('comparison.title')}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            {t('comparison.subtitle')}
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-4 font-semibold text-foreground-900">{t('comparison.feature')}</th>
                <th className="text-center px-5 py-4 font-semibold text-accent-700">{t('comparison.spreadsheet')}</th>
                <th className="text-center px-5 py-4 font-semibold text-foreground-500">{t('comparison.normal')}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} className={i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
                  <td className="px-5 py-3.5 text-foreground-700 font-medium">{row.label}</td>
                  <td className="text-center px-5 py-3.5 text-accent-700 font-semibold">{row.s}</td>
                  <td className="text-center px-5 py-3.5 text-foreground-400">{row.n}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}